<template>
    <div class="contentHome">
        <div class="centerPage">
            <el-breadcrumb separator-class="el-icon-arrow-right" class="breadCrumb">
                <el-breadcrumb-item>
                    <a href="/consultation" class="aHref">专家会议</a>
                </el-breadcrumb-item>
                <el-breadcrumb-item>会议详情</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="newCon img" :style="'backgroundImage: url('+details.thumbnailPath+')'">
                <h1 class="overflow">{{details.title}}</h1>
                <p class="overflow">{{details.subTitle}}</p>
            </div>
            <div class="detailCon">
                <div class="indicationsTit">
                    <span class="tit">会议介绍</span>
                    <p>{{details.briefDesc}}</p>
                </div>
                <div class="indicationsTit">
                    <span class="tit">会议专家</span>
                    <div class="expert flex">
                        <div class="swiperImg flex" style="cursor: pointer" v-for="(item,index) in details.doctors" :key="index" @click="doctorDetails(item)">
<!--                            <img :src="item.headImgPath" alt="" height="100%">-->
                            <div :style="'backgroundImage: url('+item.headImgPath+')'"  class="img"></div>
                            <div class="ri">
                                <strong>{{item.fullName}}</strong><br/>
                                <span>咨询专长：{{item.indications | indicationFormatter}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="indicationsTit">
                    <span class="tit">会议时间</span>
                    <p>{{details | dateFormatter}}</p>
                </div>
                <div class="indicationsTit">
                    <span class="tit">会议地点</span>
                    <p>{{details.meetPlace}}</p>
                </div>
                <div class="indicationsTit">
                    <span class="tit">会议说明</span>
                    <div v-html="details.explanation"></div>
                </div>
            </div>
            <el-button :disabled="notCanJoin" class="joinUs" :data-type="type" @click="toJoin">{{stateText[type]}}</el-button>
        </div>
    </div>
</template>

<script>
    import base from '@/api/common';

    export default {
        name: "consultationDetail",
        data() {
            return {
                id: this.$route.query.id,
                state: this.$route.query.state,
                details: {},
                notCanJoin: false,
                type: 0,
                stateText: ['立即加入','已报名','已截止报名','已结束'],

                loginState: 0
            }
        },
        mounted() {
            if (this.id) {
                this.$ajax.get(base.api.expert.consultation.details.replace("{id}", this.id)).then((res) => {
                    if (res.data.status === 'success') {
                        this.details = res.data.data;

                        // 判断可加入
                        if(this.state && Number(this.state) === 1){ // 从我的进入、当前会议已参加
                            this.notCanJoin = true;
                            this.type = 1;
                        }

                        let deadlineDate = res.data.data.deadlineDate;
                        let endDate = res.data.data.meetEndDate;
                        let now = new Date();
                        if (deadlineDate) {
                            // 判断是否可加入
                            let de = new Date(deadlineDate.replace(/-/g, "/"));
                            if(de.getTime() <= now.getTime()){
                                this.notCanJoin = true;
                                this.type = 2;
                            }
                        }
                        if(endDate){
                            let end = new Date(endDate.replace(/-/g, "/"));
                            if(end.getTime() <= now.getTime()){
                                this.type = 3;
                                return;
                            }
                        }

                        this.$ajax.get(base.api.expert.isJoin.replace("{id}",this.id)).then((res)=>{
                            if(res.data.status === 'success'){
                                this.loginState = 1;
                                if(res.data.data === 1){ //已报名
                                    this.type = 1;
                                    this.notCanJoin = true;
                                }
                            }
                        }).catch((err)=>{
                            console.error("未登录")
                        })
                    }
                })
            }
        },
        methods: {
            toJoin() {
                if(this.loginState === 0){
                    this.$router.push({name: 'login'});
                    return;
                }
                this.$router.push({name: 'signUp', query: {id: this.id}});
            },
            doctorDetails(doctor) {
                if(doctor && doctor.account){
                    this.$router.push({path: "/" + doctor.account})
                }
            }
        },
        filters: {
            dateFormatter(item) {
                let startDate = item.meetStartDate;
                let endDate = item.meetEndDate;
                if (startDate && endDate) {
                    let s = new Date(startDate.replace(/-/g, "/"));
                    let e = new Date(endDate.replace(/-/g, "/"));
                    return s.Format("yyyy年MM月dd日 HH:mm") + " - " + e.Format("yyyy年MM月dd日 HH:mm");
                }
                return "-"
            },
            indicationFormatter(indications) {
                if (indications && indications.length > 0) {
                    let arr = [];
                    $(indications).each((i, o) => {
                        arr.push(o.cnName);
                    })
                    return arr.join("、");
                }
                return "";
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../../assets/css/medication.scss';

	.newCon {
		margin-top: 20px;
	}

    .joinUs[data-type='1'],.joinUs[data-type='1']:hover{
        color: #fff;
        background-color: #409eff;
        border-color: #409eff;}
    .joinUs[data-type='2'],.joinUs[data-type='2']:hover {
        color: #fff;
        background-color: #f56c6c;
        border-color: #f56c6c;
    }
    .joinUs[data-type='3'],.joinUs[data-type='3']:hover {
        color: #fff;
        background-color: #909399;
        border-color: #909399;
    }
</style>